<template>
  <div class="app-container">
    <div :hidden="showDocument">
      <el-row :gutter="20">
        <el-col :xl="4" :lg="5" :md="6" :sm="6" :xs="24">
          <el-input v-model="filterFolderText" placeholder="搜尋文件夾名" clearable> </el-input>

          <el-tree
            ref="tree"
            class="filter-tree"
            :data="folderTreeData"
            :props="{ children: 'children', label: 'FOLDER_NAME' }"
            default-expand-all
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            node-key="ID"
            highlight-current
            @node-click="folderTreeNodeClick">
          </el-tree>
        </el-col>
        <el-col :xl="20" :lg="19" :md="18" :sm="18" :xs="24">
          <div style="display: flex; margin-bottom: 15px">
            <div style="margin-right: 15px">
              <el-input v-model="listQuery.DOC_NAME" placeholder="搜尋文件名" @keyup.enter.native="handleFilter" />
            </div>

            <div>
              <el-button
                v-loading.fullscreen.lock="fullLoading"
                plain
                round
                icon="el-icon-search"
                @click="handleFilter">
                搜尋
              </el-button>
              <el-button icon="el-icon-refresh" @click="resetFormInfo"> 重置 </el-button>
              <el-button v-if="isAssign === false" type="primary" icon="el-icon-plus" @click="handleCreate">
                新增
              </el-button>
              <el-button
                v-loading.fullscreen.lock="fullLoading"
                type="danger"
                icon="el-icon-delete"
                @click="handleBatchDelete">
                刪除
              </el-button>
            </div>
          </div>

          <el-table
            v-loading="listLoading"
            :data="docList"
            fit
            highlight-current-row
            border
            stripe
            row-key="ID"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="50px" align="center" />
            <el-table-column label="序號" type="index" width="50px" align="center" />
            <el-table-column label="文件號碼" prop="DOC_NO" align="center" show-overflow-tooltip />
            <el-table-column label="文件名" prop="DOC_NAME" align="center" show-overflow-tooltip />
            <el-table-column label="版本" prop="VERSION" align="center" show-overflow-tooltip />
            <el-table-column v-if="isAssign === false" label="歷史" align="center" show-overflow-tooltip>
              <template slot-scope="{ row }">
                <el-button size="mini" @click="openHistoryDialog(row)"> 歷史記錄 </el-button>
              </template>
            </el-table-column>
            <el-table-column
              v-if="isAssign === false"
              label="文件"
              prop="PDF_PATH"
              align="center"
              show-overflow-tooltip>
              <template slot-scope="{ row }">
                <el-button size="mini" @click="openPDFFile(row)"> 打開 </el-button>
              </template>
            </el-table-column>
            <el-table-column v-if="isAssign === false" label="設計" align="center" show-overflow-tooltip>
              <template slot-scope="{ row }">
                <el-button type="primary" size="mini" @click="showDocumentDialog(row)"> 字段設計 </el-button>
              </template>
            </el-table-column>

            <el-table-column label="更新時間" prop="LAST_UPDATE_DATE" align="center" width="160px">
              <template slot-scope="{ row }">
                <span>{{ row.LAST_UPDATE_DATE | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center" width="250px" class-name="small-padding fixed-width">
              <template slot-scope="{ row }">
                <el-button v-if="isAssign" size="mini" @click="openPDFFile(row)"> 打開 </el-button>
                <el-button v-if="isAssign" type="primary" size="mini" @click="assignDocument(row)"> Assign </el-button>
                <el-button v-if="isAssign === false" type="primary" size="mini" @click="handleUpdate(row)">
                  修改
                </el-button>
                <el-button v-if="isAssign === false" size="mini" type="danger" @click="handleDelete(row)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" /> -->
        </el-col>
      </el-row>

      <el-dialog
        :visible.sync="docDialogVisible"
        :close-on-click-modal="false"
        :show-close="false"
        :width="dialogWidth"
        :fullscreen="isMobile"
        class="pdf-dialog"
        top="5vh">
        <PDFWorkspace
          v-if="docDialogVisible"
          :key="designpdfKey1"
          ref="designpdf1"
          :is-view-mode="true"
          :is-in-dialog="true"
          :data="pdfData1"
          @updateDocHistory="updateDocHistoryList"
          @back="handleBack" />
      </el-dialog>
      <el-dialog
        title="Document History"
        :visible.sync="docHistoryListDialogVisible"
        :close-on-click-modal="false"
        width="800px">
        <el-table :data="docHistoryList" fit highlight-current-row border stripe row-key="ID">
          <el-table-column label="序號" type="index" width="50px" />
          <el-table-column label="文件號碼" prop="DOC_NO" align="center" show-overflow-tooltip />
          <el-table-column label="文件名" prop="DOC_NAME" align="center" show-overflow-tooltip />
          <el-table-column label="版本" prop="VERSION" align="center" show-overflow-tooltip />
          <el-table-column label="操作" align="center" width="250px" class-name="small-padding fixed-width">
            <template slot-scope="{ row }">
              <el-button size="mini" @click="showDocumentDialog1(row)"> 打開 </el-button>
              <el-button size="mini" type="danger" @click="handleDelete(row)"> 刪除 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <el-dialog
        :title="textMap[dialogStatus]"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        width="800px">
        <el-form
          ref="formRef"
          class="dialog-from-margin"
          :rules="rules"
          status-icon
          :model="dataform"
          label-position="left"
          label-width="100px">
          <el-form-item label="文件夾" prop="FOLDER_ID">
            <el-select ref="folderSelect" v-model="dataform.FOLDER_ID" clearable placeholder="請選擇">
              <el-option
                v-for="item in folderTreeData"
                :key="item.ID"
                :label="item.FOLDER_NAME"
                :value="item.ID"
                clearable>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文件號碼" prop="DOC_NO">
            <el-input
              v-model="dataform.DOC_NO"
              :disabled="dialogStatus === 'create' ? false : true"
              clearable
              show-word-limit
              placeholder="請輸入文件號碼" />
          </el-form-item>
          <el-form-item label="文件名" prop="DOC_NAME">
            <el-input
              v-model="dataform.DOC_NAME"
              :disabled="dialogStatus === 'create' ? false : true"
              clearable
              show-word-limit
              placeholder="請輸入文件名" />
          </el-form-item>
          <el-form-item label="版本" prop="REVERSION">
            <el-input v-model="dataform.REVERSION" disabled show-word-limit placeholder="請輸入版本" />
          </el-form-item>

          <el-form-item label="文件" prop="PDF_PATH">
            <label
              for="getFile"
              style="
                display: block;
                width: 120px;
                text-align: center;
                border: 1px solid #42b983;
                background: #42b983;
                color: white;
                border-radius: 3px;
              "
              >選擇文件</label
            >
            <input id="getFile" type="file" accept="application/pdf" style="display: none" @change="onFileChange" />
            <div>
              <span v-if="dataform.PDF_PATH"> {{ dataform.PDF_PATH }} </span>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false"> 取消 </el-button>
          <el-button type="primary" @click="dialogStatus === 'create' ? createData() : updateData()"> 確定 </el-button>
        </div>
      </el-dialog>
    </div>
    <div :hidden="!showDocument">
      <PDFWorkspace
        :key="designpdfKey"
        ref="designpdf"
        :data="pdfData"
        @updateDocHistory="updateDocHistoryList"
        @back="handleBack" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  docHistoryInfo,
  createDocHistory,
  updateDocHistory,
  deleteDocHistory,
  countDocHistory
} from '@/api/docshistory'
import { folderInfo } from '@/api/folders'

import PDFWorkspace from '@/components/PDFWorkspace'

export default {
  name: 'Docs',
  components: {
    PDFWorkspace
  },
  props: {
    isAssign: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const docNameValidator = (rule, value, callback) => {
      let query
      if (this.dialogStatus === 'create') {
        query = { DOC_NAME: value, VERSION: this.dataform.VERSION }
      } else {
        query = { DOC_NAME: value, VERSION: this.dataform.VERSION, ID: this.dataform.ID }
      }
      countDocHistory(query).then((response) => {
        if (response.data.result > 0) {
          callback(new Error('文件名已存在，請重新輸入'))
        } else {
          callback()
        }
      })
    }

    const docNoValidator = (rule, value, callback) => {
      let query
      if (this.dialogStatus === 'create') {
        query = { DOC_NO: value, VERSION: this.dataform.REVERSION }
      } else {
        query = { DOC_NO: value, VERSION: this.dataform.REVERSION, ID: this.dataform.ID }
      }
      countDocHistory(query).then((response) => {
        if (response.data.result > 0) {
          callback(new Error('文件號碼已存在，請重新輸入'))
        } else {
          callback()
        }
      })
    }

    return {
      list: [],
      docList: [],
      total: 0,
      docHistoryList: [],
      listLoading: true,
      fullLoading: false,
      listQuery: {
        FOLDER_ID: undefined,
        DOC_NAME: undefined
      },
      showDocument: false,
      designpdfKey: +new Date(),
      pdfData: {},

      pdfData1: {},
      docDialogVisible: false,
      designpdfKey1: +new Date(),

      filterFolderText: '',
      folderTreeData: [],
      dataform: {
        ID: null,
        FOLDER_ID: null,
        DOC_NO: null,
        DOC_NAME: null,
        VERSION: 1,
        REVERSION: 1,
        PDF_FILE: null,
        PDF_PATH: null,
        SIGN_DATA: '',
        EDITOR: undefined
      },

      docHistoryListDialogVisible: false,
      dialogFormVisible: false,
      dialogStatus: '',
      isMobile: false,
      textMap: {
        update: '修改',
        create: '新增'
      },
      rules: {
        FOLDER_ID: [{ required: true, message: '請選擇', trigger: 'blur' }],
        DOC_NO: [
          { required: true, message: '請輸入文件號碼', trigger: 'blur' },
          { validator: docNoValidator, trigger: 'blur' }
        ],
        DOC_NAME: [
          { required: true, message: '請輸入文件名', trigger: 'blur' },
          { validator: docNameValidator, trigger: 'blur' }
        ],
        PDF_PATH: [{ required: true, message: '請選擇文件', trigger: 'blur' }]
      },
      multipleSelection: []
    }
  },
  computed: {
    ...mapGetters(['USERNAME', 'token']),
    /**
     * 根據屏幕尺寸計算 Dialog 寬度
     */
    dialogWidth() {
      if (this.isMobile) {
        return '100%'
      }
      const screenWidth = window.innerWidth
      if (screenWidth < 768) {
        return '95%'
      } else if (screenWidth < 1200) {
        return '90%'
      } else {
        return '1200px'
      }
    }
  },
  activated: function () {
    this.getFolderTree()
    this.getList()
  },
  created() {
    this.getFolderTree()
    this.getList()
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    getList() {
      this.listLoading = true
      docHistoryInfo(this.listQuery)
        .then((response) => {
          this.list = response.data.result.rows

          this.docList = []
          let curitem
          for (let i = 0; i < this.list.length; i++) {
            if (
              curitem !== undefined &&
              this.list[i].DOC_NO === curitem.DOC_NO &&
              this.list[i].DOC_NAME === curitem.DOC_NAME
            ) {
              continue
            } else {
              curitem = this.list[i]
            }
            curitem = this.list[i]
            const curlist = this.docList.filter((x) => x.DOC_NO === curitem.DOC_NO && x.DOC_NAME === curitem.DOC_NAME)
            if (curlist.length === 0) {
              const sorted = this.list
                .filter((x) => x.DOC_NO === curitem.DOC_NO && x.DOC_NAME === curitem.DOC_NAME)
                .sort(function (a, b) {
                  return a.VERSION > b.VERSION ? -1 : 1
                })
              this.docList.push(sorted[0])
            }
          }
          this.total = this.docList.length
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    openFile() {
      try {
        document.getElementById('getFile').click()
      } catch (e) {
        // 檔案選擇失敗
      }
    },
    /**
     * 開啟文件歷史記錄對話框
     * @param {Object} row - 文件記錄
     */
    openHistoryDialog(row) {
      this.docHistoryList = this.list.filter(
        (x) => x.DOC_NO === row.DOC_NO && x.DOC_NAME === row.DOC_NAME && x.VERSION !== row.VERSION
      )
      this.docHistoryList = this.docHistoryList.sort(function (a, b) {
        return a.VERSION > b.VERSION ? 1 : -1
      })
      this.docHistoryListDialogVisible = true
    },
    openPDFFile(row) {
      // 統一使用 Dialog 內部預覽，不使用 window.open
      this.showDocumentDialog1(row)
    },
    /**
     * 開啟已簽署文件預覽
     * @param {Object} row - 簽署任務記錄（asign_doc）
     */
    openSignedPDFFile(row) {
      if (row.SIGNED_PDF_PATH && row.ID) {
        this.pdfData1 = row
        this.pdfData1.TEMPLATE_PATH = `/api/files/signed/${row.ID}`
        this.designpdfKey1 = +new Date()
        this.docDialogVisible = true
      }
    },
    designPDFField(row) {},
    /**
     * 執行文件列表篩選
     */
    handleFilter() {
      this.getList()
    },
    /**
     * 顯示文件預覽對話框（模板文件）
     * @param {Object} row - 文件記錄
     */
    showDocumentDialog1(row) {
      this.pdfData1 = row
      this.pdfData1.TEMPLATE_PATH = `/api/files/template/${row.ID}`
      this.designpdfKey1 = +new Date()
      this.docDialogVisible = true
    },
    /**
     * 顯示文件設計對話框
     * @param {Object} row - 文件記錄
     */
    showDocumentDialog(row) {
      if (row.SIGN_DATA === 'null') row.SIGN_DATA = ''
      this.pdfData = row
      this.pdfData.TEMPLATE_PATH = `/api/files/template/${row.ID}`
      this.designpdfKey = +new Date()
      this.showDocument = true
    },
    resetTemp() {
      this.dataform = {
        ID: null,
        FOLDER_ID: null,
        DOC_NO: null,
        DOC_NAME: null,
        VERSION: 1,
        REVERSION: 1,
        PDF_FILE: null,
        PDF_PATH: null,
        SIGN_DATA: undefined,
        EDITOR: undefined
      }
    },
    handleCreate() {
      this.resetTemp()
      if (document.getElementById('getFile')) {
        document.getElementById('getFile').value = null
      }
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate()
      })
    },
    createData() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.fullLoading = true
          const formDat = new FormData()
          formDat.append('FOLDER_ID', this.dataform.FOLDER_ID)
          formDat.append('DOC_NO', this.dataform.DOC_NO)
          formDat.append('DOC_NAME', this.dataform.DOC_NAME)
          formDat.append('VERSION', this.dataform.REVERSION)
          formDat.append('PDF_FILE', this.dataform.PDF_FILE)
          formDat.append('EDITOR', this.USERNAME)

          createDocHistory(formDat, { 'Content-Type': 'multipart/form-data' })
            .then(() => {
              this.fullLoading = false
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
                duration: 2000
              })
              this.getList()
            })
            .catch(() => {
              this.fullLoading = false
              this.dialogFormVisible = false
            })
        }
      })
    },
    handleUpdate(row) {
      if (document.getElementById('getFile')) {
        document.getElementById('getFile').value = null
      }
      this.dataform = Object.assign({}, row)
      this.dataform.REVERSION = this.dataform.VERSION
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate()
      })
    },
    updateData() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.fullLoading = true
          if (this.dataform.SIGN_DATA === 'null') this.dataform.SIGN_DATA = ''

          if (this.dataform.REVERSION === this.dataform.VERSION) {
            const tempData = Object.assign({}, this.dataform)
            tempData.EDITOR = this.USERNAME
            updateDocHistory(tempData)
              .then(() => {
                this.fullLoading = false
                this.dialogFormVisible = false
                this.$notify({
                  title: '成功',
                  message: '修改成功',
                  type: 'success',
                  duration: 2000
                })
                this.getList()
              })
              .catch(() => {
                this.fullLoading = false
                this.dialogFormVisible = false
              })
          } else {
            const formDat = new FormData()
            formDat.append('ID', this.dataform.ID)
            formDat.append('FOLDER_ID', this.dataform.FOLDER_ID)
            formDat.append('DOC_NO', this.dataform.DOC_NO)
            formDat.append('DOC_NAME', this.dataform.DOC_NAME)
            formDat.append('VERSION', this.dataform.REVERSION)
            formDat.append('PDF_FILE', this.dataform.PDF_FILE)
            formDat.append('SIGN_DATA', this.dataform.SIGN_DATA)
            formDat.append('EDITOR', this.USERNAME)

            createDocHistory(formDat, { 'Content-Type': 'multipart/form-data' })
              .then(() => {
                this.fullLoading = false
                this.dialogFormVisible = false
                this.$notify({
                  title: '成功',
                  message: '修改成功',
                  type: 'success',
                  duration: 2000
                })
                this.getList()
              })
              .catch(() => {
                this.fullLoading = false
                this.dialogFormVisible = false
              })
          }
        }
      })
    },
    handleDelete(row) {
      this.$confirm('確認刪除該記錄？', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'error'
      })
        .then(() => {
          this.fullLoading = true
          deleteDocHistory(row.ID)
            .then(() => {
              this.fullLoading = false
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
                duration: 2000
              })
              this.handleFilter()
              this.docHistoryList = this.docHistoryList.filter((x) => x.VERSION !== row.VERSION)
            })
            .catch(() => {
              this.fullLoading = false
            })
        })
        .catch(() => {
          // 不執行任何動作
        })
    },
    handleBatchDelete() {
      if (!this.multipleSelection.length) {
        this.$message({ type: 'info', message: '請勾選你要刪除的數據' })
        return
      }

      this.$confirm('確認刪除該記錄？', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.fullLoading = true
          const promises = []

          this.multipleSelection.forEach((id) => {
            promises.push(deleteDocHistory(id))
          })

          Promise.all(promises)
            .then(() => {
              this.fullLoading = false
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
                duration: 2000
              })
              this.handleFilter()
            })
            .catch(() => {
              this.fullLoading = false
            })
        })
        .catch(() => {
          // 不執行任何動作
        })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.ID)
    },
    /**
     * 重置篩選條件
     */
    resetFormInfo() {
      this.$refs.tree.setCurrentKey(null)
      this.listQuery.FOLDER_ID = undefined
      this.listQuery.DOC_NAME = undefined
      this.getList()
    },
    assignDocument(row) {
      this.$emit('assignDoc', row)
    },
    /**
     * 獲取文件夾樹狀結構
     */
    getFolderTree() {
      folderInfo().then((response) => {
        this.folderTreeData = response.data.result.rows
      })
    },
    handleBack() {
      this.showDocument = false
      this.docDialogVisible = false
    },
    updateDocHistoryList(docData) {
      for (let j = 0; j < this.list.length; j++) {
        if (this.list[j].ID === docData.ID) {
          this.list[j].SIGN_DATA = docData.SIGN_DATA
          this.list[j].SIGNED_PDF_PATH = docData.SIGNED_PDF_PATH
          return
        }
      }
    },
    /**
     * 文件夾樹節點過濾方法
     * @param {string} value - 搜尋關鍵字
     * @param {Object} data - 節點數據
     * @returns {boolean} 是否顯示該節點
     */
    filterNode(value, data, node) {
      if (!value) return true
      return data.FOLDER_NAME.toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) !== -1
    },
    /**
     * 文件夾樹節點點擊事件
     * @param {Object} data - 節點數據
     */
    folderTreeNodeClick(data) {
      this.listQuery.FOLDER_ID = data.ID
      this.handleFilter()
    },
    onFileChange(e) {
      const file = e.target.files[0]
      try {
        if (file && file.type === 'application/pdf') {
          this.dataform.PDF_PATH = file.name
          this.dataform.PDF_FILE = file
          if (this.dialogStatus === 'create') this.dataform.REVERSION = 1
          else this.dataform.REVERSION = this.dataform.VERSION + 1
        } else {
          this.$notify({
            title: 'Error',
            message: 'Please select pdf file！',
            type: 'error',
            duration: 2000
          })
        }
      } catch (e) {
        // 檔案處理失敗，靜默處理
      }
    },
    /**
     * 處理窗口大小變更
     */
    handleResize() {
      this.isMobile = window.innerWidth < 768
    }
  }
}
</script>
<style lang="scss" scoped>
.table-expand-title {
  font-size: 0;

  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  /deep/ label {
    color: #99a9bf;
  }
}

.filter-tree {
  margin-top: 2vh;
}

.tags-margin {
  margin-right: 0.5vw;
}

// PDF Dialog 專用樣式
// 遵循 70/20/10 顏色分配原則：
// 70% 主色（白色背景）
// 20% 次要色（#304156 主題色）
// 10% 強調色（#42b983 綠色，僅用於需要強調的地方）
::v-deep .pdf-dialog {
  .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 5vh auto !important;
    max-height: 90vh;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
    background: #fff; // 70% 主色
    border: none; // 移除邊框，使用陰影代替
  }

  // 隱藏標題欄，只保留返回按鈕
  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    flex: 1;
    overflow: hidden;
    padding: 0;
    display: flex;
    flex-direction: column;
    background: #fff; // 70% 主色
  }

  .el-dialog__footer {
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    .el-dialog {
      margin: 0 !important;
      width: 100% !important;
      height: 100% !important;
      max-height: 100vh;
      border-radius: 0;
    }
  }
}
</style>
